import Nav from "@/components/Nav";
import ChurchBanner from "@/components/ChurchBanner";
import UpcomingEvents from "@/components/UpcomingEvents";
import Hero from "@/components/Hero";
import ScriptureMarquee from "@/components/ScriptureMarquee";
import Ministers from "@/components/Ministers";
import Engines from "@/components/Engines";
import WeeklyMessage from "@/components/WeeklyMessage";
import Manifesto from "@/components/Manifesto";
import Library from "@/components/Library";
import ComeToWater from "@/components/ComeToWater";
import Connect from "@/components/Connect";
import PlanVisit from "@/components/PlanVisit";
import Apparel from "@/components/Apparel";
import Give from "@/components/Give";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="grain relative bg-[#05030A] min-h-screen" data-testid="landing-page">
      <Nav />
      <ChurchBanner />
      <UpcomingEvents />
      <Hero />
      <ScriptureMarquee />
      <Ministers />
      <Engines />
      <WeeklyMessage />
      <Manifesto />
      <Library />
      <ComeToWater />
      <Connect />
      <PlanVisit />
      <Apparel />
      <Give />
      <Footer />
    </div>
  );
}
